/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
var o;!function(o){o.Continuous="continuous",o.Hourly="hourly"}(o||(o={}));export{o as DurationMode};
